import formReducer from "./Reducer";

import { combineReducers } from "redux";

const rootReducer = combineReducers({formReducer});

export default rootReducer;